// extracted by mini-css-extract-plugin
module.exports = {"root":"Comment-root-3F0u-","highlight":"Comment-highlight-2r8jI","subBar":"Comment-subBar-1TO1F","footer":"Comment-footer-2InBE"};